import { render } from "./createProductForm.vue?vue&type=template&id=2ceb439e&scoped=true"
import script from "./createProductForm.vue?vue&type=script&lang=js"
export * from "./createProductForm.vue?vue&type=script&lang=js"

import "./createProductForm.vue?vue&type=style&index=0&id=2ceb439e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ceb439e"]])

export default __exports__